import { LocaleManager } from './locale-manager';
import type { TenantId } from 'tenants/types/tenant';

/**
 * Parameters for checking if untranslated content should be shown.
 */
export interface ShouldShowUntranslatedContentParams {
  /** The tenant ID */
  tenantId: TenantId;
  /** The locale from the route (context.locale) */
  routeLocale?: string;
  /** The cookie header from the request (context.req.headers.cookie) */
  requestCookies?: string;
}

/**
 * Determines if untranslated content should be shown.
 * 
 * Content is only shown when the current locale matches the tenant's default locale,
 * since most content is authored in English and not translated.
 * 
 * @param params - Configuration object
 * @returns true if content should be shown (locale matches tenant default), false otherwise
 *
 */
export function shouldShowUntranslatedContent(
  params: ShouldShowUntranslatedContentParams
): boolean {
  const { tenantId, routeLocale, requestCookies } = params;
  const localeManager = LocaleManager.forServer(tenantId, routeLocale, requestCookies);
  const currentLocale = localeManager.getCurrentLocale();
  const defaultLocale = localeManager.getDefaultLocale();
  
  return currentLocale === defaultLocale;
}

